import * as React from 'react';
import { Box, styled, SxProps, Theme, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Palette } from '../@shared/palette';
import { JSX } from 'react';

type ContextHelperType = {
    boxSx?: SxProps<Theme>,
    children: JSX.Element,
    content?: JSX.Element,
    size?: "small" | "medium" | "large";
    placement?: "top" | "bottom" | "left" | "right";
}

export const ContextHelper = (props: ContextHelperType) => {
    return <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        ...props.boxSx
    }}>
        {props.children}
        <Box sx={{lineHeight: 0}}>
            {props.content && <HtmlTooltip title={props.content} placement={props.placement} arrow>
                <InfoOutlinedIcon sx={{ cursor: "pointer", fontSize: "1rem", color: Palette.textColorSecondary }} />
            </HtmlTooltip>}
        </Box>
    </Box>
}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
    },
}));